import axios from "axios";
import * as API from "./graph";

const lastBarsCache = new Map();
const configurationData = {
  supported_resolutions: ["1", "5", "15", "30", "60", "1D", "1W", "1M"],
};

const getIsoDate = (date) => new Date(date).toISOString();

export default {
  onReady: (callback) => {
    console.log("[onReady]: Method called!!");
    setTimeout(() => callback(configurationData));
  },
  resolveSymbol: async (
    symbolName,
    onSymbolResolvedCallback,
    onResolveErrorCallback
  ) => {
    console.log("[resolveSymbol]: Method called!!");
    const response = await axios.get(
      `${API.endpoint}/info?tokenAddress=${symbolName}`
    );

    const coin = response.data.baseCurrency;
    if (!coin) {
      onResolveErrorCallback();
    } else {
      const symbol = {
        ticker: symbolName,
        name: `${coin.symbol}/BNB`,
        session: "24x7",
        timezone: "Etc/UTC",
        minmov: 1,
        pricescale: 10000000,
        has_intraday: true,
        intraday_multipliers: ["1", "5", "15", "30", "60"],
        has_empty_bars: true,
        has_weekly_and_monthly: false,
        supported_resolutions: configurationData.supported_resolutions,
        volume_precision: 1,
        data_status: "streaming",
      };
      //onSymbolResolvedCallback(symbol);
      onSymbolResolvedCallback(symbol);
    }
  },
  getBars: async (
    symbolInfo,
    resolution,
    periodParams,
    onHistoryCallback,
    onErrorCallback
  ) => {
    const { from, to, firstDataRequest } = periodParams;
    console.log(`🚀 > periodParams`, periodParams);
    try {
      if (resolution === "1D") {
        resolution = 1440;
      }
      const res = await axios.get(
        `${API.endpoint}/bars?from=${getIsoDate(from * 1000)}&to=${getIsoDate(
          to * 1000
        )}&interval=${Number(resolution)}&tokenAddress=${symbolInfo.ticker}`
      );

      const bars = res.data.map((el) => ({
        time: new Date(el.timeInterval.minute).getTime(), // date string in api response
        low: el.low,
        high: el.high,
        open: Number(el.open),
        close: Number(el.close),
        volume: el.volume,
      }));

      if (bars.length) {
        if (firstDataRequest) {
          lastBarsCache.set(symbolInfo.full_name, {
            ...bars[bars.length - 1],
          });
        }
        onHistoryCallback(bars, { noData: false });
      } else {
        onHistoryCallback(bars, { noData: true });
      }
    } catch (err) {
      console.log({ err });
      // onErrorCallback(err)
    }
  },
  subscribeBars: (
    symbolInfo,
    resolution,
    onRealtimeCallback,
    subscribeID,
    onResetCacheNeededCallback
  ) => {},
  unsubscribeBars: (subscribeID) => {},
};



// WEBPACK FOOTER //
// ./src/components/TVChartContainer/datafeed.js